import React, { useEffect, useState } from "react";
import cardsBg from "assets/images/common/others/cardsBg.png";
import useUsers from "containers/user-management/useHooks";
import { BAGDE_TYPES } from "utils/helpers/enums/shared.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { useSelector } from "react-redux";
import DataNotFound from "components/particles/table/data-not-found";
import { BADGE_TYPE } from "utils/helpers/enums/roles.enum";

interface Props {
  ambassadorId: number;
}

const Badges = ({ ambassadorId }: Props) => {
  const { getUserBadges } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [achievements, setAchievements] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const loadBadges = async (page: number = 0) => {
    await getUserBadges(
      setAchievements,
      {
        page,
        size: 4,
        badgeType: BADGE_TYPE.ACHIEVEMENT,
        userId: ambassadorId,
      },
      page,
      setHasMore
    );
    setPage(page + 1);
  };

  useEffect(() => {
    loadBadges(0);
  }, []);

  const handleLoadMore = () => {
    loadBadges(page);
  };

  return (
    <div>
      <div className="flex flex-wrap gap-4 py-2">
        {achievements.map((badge, index) => (
          <div
            key={badge?.id || `badge-${index}`}
            className="flex flex-col items-center justify-center border border-borderLightGray p-3 rounded-lg w-[235px] h-[260px]"
            style={{ backgroundImage: `url(${cardsBg})` }}
          >
            <div className="hover:scale-110 transition-transform duration-300">
              <img
                className="w-[165px] h-[177px]"
                src={
                  badge?.image
                    ? concatPathWithBackendUrl(badge?.image?.name)
                    : editProfilePicUser
                }
              />
            </div>
            <span className="text-sm font-medium text-primaryText mt-3">
              {badge?.name || "--"}
            </span>
          </div>
        ))}
      </div>

      {hasMore && (
        <div className="flex justify-center mt-4">
          <button
            onClick={handleLoadMore}
            className="px-4 py-2 text-sm font-semibold text-white bg-lightBlueColor rounded"
          >
            See More
          </button>
        </div>
      )}

      <div className="">
        <DataNotFound show={!isLoading && !achievements.length} />
      </div>
    </div>
  );
};

export default Badges;
